import {ViewPopup} from './ViewPopup.ts'
import {ClientUserState} from '../ClientUserState.ts'

export class ViewPopupDiscordSettings extends ViewPopup {
    constructor() {
        super({key: 'strings:popups.errors.discordRedirectToWeb.title'}, {key: 'strings:popups.errors.discordRedirectToWeb.body', options: {username: ClientUserState.userState?.username}}, () => undefined, () => undefined, false)
        super.removeXButton()
        super.show()
    }
}
